<template>
  <b-card no-body>
   
    <b-card-header class="pb-50">
      <h5> {{ $t('Fill Areas Filter')}} </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
       

        <b-col lg="6" md="6" class="mb-md-0 mb-2">
          <label>{{$t('Owners')}}</label>
          <v-select multiple  :close-on-select="false"
               :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
                   
                    label="name"
                    :options="areasOwnersOptions"
                    v-model="filter_request.areas_owners"
                    class="w-100"
                    :reduce="val => val.id"
                    v-on:input="filterDataChanged"
          />
        </b-col>

      

        <b-col lg="6" md="6" class="mb-md-0 mb-2">
          <label>{{$t('Contracts')}}</label>
          <v-select multiple :close-on-select="false"
          :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
                   
                    :getOptionLabel="c => c.name"
                    :options="areasContractsOptions"
                    v-model="filter_request.areas_contracts"
                    class="w-100"
                    :reduce="val => val.id"
                     v-on:input="filterDataChanged"
          />
        </b-col>


      </b-row>
     
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BButton, VBToggle, BCollapse
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Filter   from './filter.js'
import FilterLogic   from './filterLogic.js'
import { ReportService } from '@/app/reports/share/report.service'
import store from '@/store'
export default {
  components: {
    BRow,BButton,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  setup(props, { emit }){
   const {filter_request,reFilter,geofences}  =FilterLogic();
   const{
     areasOwnersOptions
     ,areasCategoriesOptions
     ,areasContractsOptions
     ,areasContractsOptions_orig
    }= Filter('geofence')

  
  const renameKeys = (obj) =>{
  const keyValues = Object.keys(obj).map(key => {
   
    return { [key.substring(6)]: obj[key] };
  });
  return Object.assign({}, ...keyValues);
}
     const refliterContractByWoners=(owners)=>{
          
          let result=areasContractsOptions_orig.value.filter((i)=>owners.includes(i.contractor_id))
         
           areasContractsOptions.value=result;
           if(owners.length==0){
            areasContractsOptions.value=areasContractsOptions_orig.value;
          }
         
        }


   const filterDataChanged =()=>{
    refliterContractByWoners(filter_request.value.areas_owners)
   
 let new_request=   renameKeys(filter_request.value)
  
    emit('merageGeofencesFilterWithRequest', filter_request.value);
   ReportService.getAreasOptions(
      Object.assign( new_request,{
       type:'geofence',
       categories:['FILL_AREA'],
       user: store.state.auth.userData.id
   
   })
     ).then(response => {
       
       geofences.value = response.data.map((d)=>({id:d.id,"name":d.name}))
             emit('geofencesFilterd', geofences.value);
          
      })
     .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
     .finally(() => {})
   

   }

    return { 
    areasOwnersOptions,
   
    areasCategoriesOptions,
    areasContractsOptions,
    filter_request,
    filterDataChanged,
    reFilter,
    geofences,ReportService

    }

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
